import { render, staticRenderFns } from "./dataCenter.vue?vue&type=template&id=f191babc&scoped=true"
import script from "./dataCenter.vue?vue&type=script&lang=js"
export * from "./dataCenter.vue?vue&type=script&lang=js"
import style0 from "./less/center.less?vue&type=style&index=0&id=f191babc&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f191babc",
  null
  
)

export default component.exports